import React from "react";
// reactstrap components
import img1 from 'assets/img/landing/about/About_Landing-08.png';
import img2 from 'assets/img/landing/about/About_Landing-09.png';
import img3 from 'assets/img/landing/about/About_Landing-10.png';
import img4 from 'assets/img/landing/about/About_Landing-11.png';
import img5 from 'assets/img/landing/about/About_Landing-12.png';
import img6 from 'assets/img/landing/about/About_Landing-14.png';
import img7 from 'assets/img/landing/about/About_Landing-15.png';
import Abouts from './about_elements.js';
import "assets/css/about.css";
import "assets/css/landing.css"
import Menu from './Menu.js';
import Footer from './footer.js';
class Home extends React.Component {

  state ={

        avisibles:false,
        
    }
    visible = () =>{
        this.setState({
            avisibles:!this.state.avisibles
        })
        
    }

 componentDidMount(){
        window.scrollTo(0,0);
    }
  render() {
    return (
      <>  
        <Menu/>
         <div id="abouts" className={(this.state.avisibles===false ? 'landing2 hero ' :'landing hero')} >
        <div className="div-1"></div>
        <div className="div-2"></div>
        <div className="div-3">
          <img src={img1} alt="s" className="simgr img1" />
                <img src={img2} alt="s" className="imgr img2"/>
                <img src={img3}  alt="s" className="simgr img3"/>
                <img src={img4} alt="s" className="simgr img4"/>
                <img src={img5}  alt="s" className="simgr img5"/>
                <img src={img6} alt="s" className="simgr img6"/>
                <img src={img7} alt="s" className="simgr img7"/> 
        </div>
        <div className="div-4">
            <h1 className="about_title_heading">About</h1>
        </div>
        <div className="sdiv-3 buttons buttonsa">
            </div>
    </div>
    {this.state.avisibles===false && <Abouts/>}
    <Footer/>
    <div className="landscape-view">
      <div className="phone">
</div>
<div className="message">
  Please rotate your device!
</div>
    </div>
    
      </>
    );
  }
}

export default Home;
